@import '../../../node_modules/@ticom/global-css/dist/core/patterns/core.textwithicon';

:host {
    ti-button {
        white-space: inherit;
        .ti-notify-me-icon-text{
            @include ti_c-iconText();
        }
    }
}
